import { render } from "./ChangePassword.vue?vue&type=template&id=bb7bfe3a&scoped=true"
const script = {}

import "../styles/changePassword.css?vue&type=style&index=0&id=bb7bfe3a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7bfe3a"]])

export default __exports__